import { useMemo, useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Card from "../Card";
import Title from "../Title";
import { ReactSortable } from "react-sortablejs";
import urlSlug from "url-slug";
import moment from "moment";
import {
  Button,
  Divider,
  Space,
  Switch,
  Upload,
  Input,
  Radio,
  Select,
  Drawer,
  Col,
  Modal,
  Row,
  DatePicker,
  notification,
  Form,
  Tag,
} from "antd";
import CardList from "../CardList";
import { ReactComponent as IconOk } from "../../../Assets/Images/Backoffice/Ok.svg";
import { ReactComponent as IconCalendar } from "../../../Assets/Images/Backoffice/Calendar.svg";
import { ReactComponent as IconClose } from "../../../Assets/Images/Backoffice/Close.svg";
import { ReactComponent as IconEdit } from "../../../Assets/Images/Backoffice/Edit.svg";
import { ReactComponent as IconHours } from "../../../Assets/Images/Backoffice/Hours.svg";
import { ReactComponent as IconUpload } from "../../../Assets/Images/Backoffice/Upload.svg";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";
import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { EyeOutlined } from "@ant-design/icons";
import axios, { all } from "axios";
import ImageResize from "quill-image-resize-module-react";
Quill.register("modules/imageResize", ImageResize);

const { RangePicker } = DatePicker;
const { Dragger } = Upload;
const { TextArea } = Input;

// import { useDrag } from 'react-dnd'
// import { ItemTypes } from './Constants'

const WrapperCardList = styled.section`
  // display: flex;
  width: 100% !important;
  flex-direction: row;

  .ant-form-item {
    margin-bottom: 1px !important;
  }

  .datepicker {
    width: 200px;
    height: 40px;
    border: 1px solid rgb(128, 159, 184);
  }

  p {
    color: #c2c4d4;
    font-size: 14px;
    letter-spacing: 0px;
    line-height: 20px;
    margin-bottom: 0% !important;
    text-align: left;
  }

  .text {
    color: #809fb8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .regular-text {
    color: #000;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .text-small {
    color: #809fb8;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .css-dev-only-do-not-override-j0nf2s .text {
    margin-bottom: 0 !important;
  }

  .icon-close {
    cursor: pointer;
  }

  .action-edit {
    cursor: pointer;
    color: #494d7d;
  }

  .flex-wrap {
    flex-wrap: wrap !important;
  }
`;

const WrapperCardApresentacao = styled.section`
  display: flex;
  flex-direction: column;

  .text-preview-desc, .text-preview-desc p {
    font-size: 14px !important;
    color: #c2c4d4;
  }

  .space-dates .ant-space-item, .space-dates .ant-row {
    width: 100% !important;
  }

  .w-100 {
    width: 100%;
  }

  .datepicker-input {
    width: 100% !important;
    height: 40px !important; 
    border: 1px solid #ccc !important;
  }

  .justify-end {
    display: flex;
    justify-content: flex-end !important;
    width: 100%;
    align-items: baseline !important;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 20px;
  }

  .icon {
    width: 25px;
  }

  .size-eye svg {
    width: 25px;
  }

  .ant-upload-btn {
    min-height: 100px;
  }

  .ant-radio-button-wrapper {
    height: 40px;
    border: 1px solid #ccc;
  }

  .ant-radio-button-wrapper span {
    line-height: 40px; 
    font-size: 14px;s
  }
  .text {
    margin-bottom: 0% !important;
  }

  h4 {
    text-align: center;
    font: normal normal bold 20px/20px Roboto;
    letter-spacing: 0px;
    color: #050505;
  }
  

  .text {
    color: #809FB8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .center {
    text-align: center;
  }

  .ant-upload-wrapper .ant-upload-drag {
    max-height: -webkit-fill-available;
    height: 91%;
    display: flex;
    justify-content: center;
  }

  .ant-upload-wrapper .ant-upload-drag .ant-upload-btn  {
    height: -webkit-fill-available;
  }

  .div-sortable {
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
  }

  .div-sortable .ant-col {
    padding: 5px;
  }

  .div-apresentacao{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .cta {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 40px !important;
    line-height: 18px;

    i { margin: 0 3px; }

    a { text-decoration: none; }
  }

  


  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #FFF;
    }
  }
`;

const ContentFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 40px;
    line-height: 18px;

    i {
      margin: 0 3px;
    }
  }

  a {
    text-decoration: none;
  }
`;

var styles = {
  h6_label: {
    color: "#809FB8",
    fontFamily: "Roboto",
    fontSize: "15px",
    marginTop: "1%",
  },
  input_class_disabled: {
    marginBottom: "2%",
    borderRadius: "6px",
    height: "40px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    opacity: 0.6,
    pointerApresentacaos: "none",
  },
  input_class: {
    borderRadius: "6px",
    height: "40px",
    border: "1px solid #ccc",
    color: "#0C1151",
    width: "100%",
  },
  select_class: {
    borderRadius: "6px",
    height: "40px",
    color: "#0C1151",
    width: "100%",
  },
  textarea_class: {
    borderRadius: "6px",
    border: "1px solid #809FB8",
    color: "#0C1151",
  },
  switch_label: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "bold",
    height: "40px",
    borderRadius: "8px",
    padding: "0px 16px",
    color: "#809FB8",
    border: "1px solid #ccc",
    textAlign: "center",
  },
  upload: {
    width: "100%",
  },
};

const CardHeader = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto auto;
`;

export default function CardApresentacoes(props) {
  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const quillRef = useRef();
  const [fileApresentacaoList, setfileApresentacaoList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isCursoCongresso, setIsCursoCongresso] = useState(false);
  const [isFormacaoOnline, setIsFormacaoOnline] = useState(false);
  const [isCursoCongressoEdit, setIsCursoCongressoEdit] = useState(0);
  const [isFormacaoOnlineEdit, setIsFormacaoOnlineEdit] = useState(0);
  const [showApresentacaoDrawer, setShowApresentacaoDrawer] = useState(false);
  // editar Apresentacao
  const [fileApresentacaoListEdit, setfileApresentacaoListEdit] = useState([]);
  const [showCraftDrawer, setShowCraftDrawer] = useState(false);
  const [apresentacaoIdEdit, setapresentacaoIdEdit] = useState("");
  const [isTemplateMode, setIsTemplateMode] = useState(false);
  const [descricaoApresentacaoEdit, setDescricaoApresentacaoEdit] =
    useState("");
  const [imagemDestaqueEdit, setImagemDestaqueEdit] = useState("");
  const [idToRemove, setIdToRemove] = useState(false);
  const [titleToRemove, setTitleToRemove] = useState(false);
  const [removeApresentacaoModalOpen, setRemoveApresentacaoModalOpen] =
    useState(false);
  const [editModeDescricao, setEditModeDescricao] = useState(false);

  const [allItems, setAllItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [formacoesOnline, setFormacoesOnline] = useState([]);
  const [cursosCongressos, setCursosCongressos] = useState([]);
  const [sobPesquisa, setSobPesquisa] = useState([]);
  const [showSocios, setShowSocios] = useState(false);
  const [showNaoSocios, setShowNaoSocios] = useState(false);
  const [showNaoRegistados, setShowNaoRegistados] = useState(false);

  const [showSociosEdit, setShowSociosEdit] = useState(false);
  const [showNaoSociosEdit, setShowNaoSociosEdit] = useState(false);
  const [showNaoRegistadosEdit, setShowNaoRegistadosEdit] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null); // criar
  const [categoriaSelecionadaEdit, setCategoriaSelecionadaEdit] =
    useState(null); // editar
  const [novaCategoria, setNovaCategoria] = useState("");
  const inputCategoriaRef = useRef(null);

  const [isSobPesquisa, setIsSobPesquisa] = useState(false);
  const [isSobPesquisaEdit, setIsSobPesquisaEdit] = useState(0);

  const isTemplateId = (value) => {
    return /^\d+$/.test(value);
  };

  const handleAddCategoria = () => {
    if (!novaCategoria) return;

    // evitar duplicados
    if (categorias.includes(novaCategoria)) return;

    setCategorias([...categorias, novaCategoria]);
    setCategoriaSelecionada(novaCategoria);
    setNovaCategoria("");

    setTimeout(() => {
      inputCategoriaRef.current?.focus();
    }, 0);
  };

  const stringToDate = (dataStr) => {
    const [dia, mes, ano] = dataStr.split("/").map(Number);
    return new Date(ano, mes - 1, dia); // Meses são de 0 a 11
  };

  const handleApresentacoes = (allApresentacoes, allEditors) => {
    let apresentacoesToShow = [];

    allApresentacoes?.forEach((apresentacao) => {
      if (!apresentacao) return;

      // Formatar data de criação
      let criado_em = new Date(apresentacao.created_at);
      apresentacao.created_at = criado_em.toLocaleDateString();

      // Criar slug
      apresentacao.slug = urlSlug(apresentacao.titulo) + "-" + apresentacao.id;

      // Status
      let status = "published";
      let today = new Date();

      if (apresentacao.start_post?.length === 10) {
        let startPostDate = stringToDate(apresentacao.start_post);
        if (today < startPostDate) status = "scheduled";
      }

      if (apresentacao.end_post?.length === 10) {
        let endPostDate = stringToDate(apresentacao.end_post);
        if (today > endPostDate) status = "expired";
      }

      apresentacao.status = status;

      apresentacao.descricaoParaMostrar = apresentacao.descricao;

      if (!isNaN(apresentacao.descricao)) {
        // converter para número
        const editorId = Number(apresentacao.descricao);
        const editorEncontrado = allEditors.find(
          (editor) => editor.id == editorId
        );
        apresentacao.editor = editorEncontrado ? editorEncontrado.name : "";
        apresentacao.descricaoParaMostrar =
          "Template utilizado: " + apresentacao.editor;
      }

      const categoriasUnicas = [
        ...new Set(
          allApresentacoes
            ?.map((a) => a.categoria)
            .filter((c) => c && c.trim() !== "")
        ),
      ];

      setCategorias(categoriasUnicas);

      apresentacoesToShow.push(apresentacao);
    });

    setCursosCongressos(
      apresentacoesToShow
        .filter((a) => a.curso_congresso == 1)
        .sort((a, b) => a.ordem - b.ordem)
    );
    setFormacoesOnline(
      apresentacoesToShow
        .filter((a) => a.formacao_online == 1)
        .sort((a, b) => a.ordem - b.ordem)
    );
    setSobPesquisa(
      apresentacoesToShow
        .filter((a) => a.sob_pesquisa == 1)
        .sort((a, b) => a.ordem - b.ordem)
    );
  };

  useEffect(() => {
    fetch(`https://api.spap.pt/api/all-apresentacoes`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar apresentacoes");
        }
        return response.json();
      })
      .then((data) => {
        handleApresentacoes(data.apresentacoes, data.editors);
        setTemplates(data.editors);
      })
      .catch((error) => console.error(error));
  }, []);

  const [currentItemsApresentacao, setCurrentItemsApresentacao] = useState(
    allItems.slice(0, 2)
  );

  const [itemOffsetApresentacao, setItemOffsetApresentacao] = useState(0);
  const itemsPerPageApresentacao = 2;

  const handlePageApresentacao = (page) => {
    const newOffset = ((page - 1) * itemsPerPageApresentacao) % allItems.length;
    setItemOffsetApresentacao(newOffset);
  };

  useEffect(() => {
    const endOffset = itemOffsetApresentacao + itemsPerPageApresentacao;
    setCurrentItemsApresentacao(
      allItems.slice(itemOffsetApresentacao, endOffset)
    );
  }, [itemOffsetApresentacao, allItems]);

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 5,
    rtl: false,
  });

  const clickToApresentacaoDrawer = (item) => {
    setapresentacaoIdEdit(item.id);
    editForm.setFieldsValue({
      titulo: item.titulo,
      start_post:
        item.start_post?.length == 10
          ? dayjs(item.start_post, "DD/MM/YYYY")
          : null,
      end_post:
        item.end_post?.length == 10 ? dayjs(item.end_post, "DD/MM/YYYY") : null,
      start_event:
        item.start_event?.length == 10
          ? dayjs(item.start_event, "DD/MM/YYYY")
          : null,
      end_event:
        item.end_event?.length == 10
          ? dayjs(item.end_event, "DD/MM/YYYY")
          : null,
      descricao: String(item.descricao),
    });

    setCategoriaSelecionadaEdit(item.categoria);
    setDescricaoApresentacaoEdit(String(item.descricao));
    setIsSobPesquisaEdit(item.sob_pesquisa);

    if (/^\d+$/.test(item.descricao)) {
      setIsTemplateMode(true);
    } else {
      setIsTemplateMode(false);
    }
    setIsFormacaoOnlineEdit(item.formacao_online);
    setIsCursoCongressoEdit(item.curso_congresso);
    setImagemDestaqueEdit(item.imagem_destaque);
    setShowSociosEdit(item.show_socios == 1);
    setShowNaoSociosEdit(item.show_nao_socios == 1);
    setShowNaoRegistadosEdit(item.show_nao_registados == 1);
    setShowSociosEdit(item.show_socios == 1);
    setShowNaoSociosEdit(item.show_nao_socios == 1);
    setShowNaoRegistadosEdit(item.show_nao_registados == 1);

    setShowApresentacaoDrawer(true);
  };

  const propApresentacao = {
    onRemove: (file) => {
      const index = fileApresentacaoList.indexOf(file);
      const newfileApresentacaoList = fileApresentacaoList.slice();
      newfileApresentacaoList.splice(index, 1);
      setfileApresentacaoList(newfileApresentacaoList);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });

        return isImage || Upload.LIST_IGNORE;
      }
      setfileApresentacaoList([...fileApresentacaoList, file]);
      return false;
    },
    fileApresentacaoList,
  };

  const t = 1;
  const data = [];

  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1200,
    useWebWorker: true,
  };

  const handleImageUpload = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      // Limite de 1MB
      if (file.size > 1024 * 1024) {
        notification.error({
          description: "O tamanho da imagem não pode ultrapassar 1 MB.",
        });
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await fetch("https://api.spap.pt/api/media/upload", {
          method: "POST",
          body: formData,
          headers: {
            Authorization: "Bearer " + session_storage.token,
          },
        });
        const data = await res.json();
        if (data.url) {
          const quill = quillRef.current.getEditor();
          const range = quill.getSelection();
          const position = range ? range.index : quill.getLength();
          quill.insertEmbed(position, "image", data.url);
          quill.setSelection(position + 1);
        }
      } catch (err) {
        console.error(err);
        notification.error({
          description: "Erro ao enviar a imagem. Tente novamente.",
        });
      }
    };
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, false] }],
          [{ font: [] }],
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          ["link", "image", "video"],
          ["clean"],
        ],
        handlers: {
          image: handleImageUpload, // handler customizado
        },
      },
      clipboard: {
        matchVisual: false,
      },
      imageResize: {
        // parchment: Quill.import('parchment'),
        modules: ["Resize", "DisplaySize"],
      },
    }),
    []
  );

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  const editDescricao = () => {
    setDescricaoApresentacaoEdit(descricaoApresentacaoEdit);
    setEditModeDescricao(true);
  };

  const handleApresentacao = (e) => {
    let startPost = e.start_post ? e.start_post.format("DD/MM/YYYY") : null;
    let endPost = e.end_post ? e.end_post.format("DD/MM/YYYY") : null;
    let startEvent = e.start_event ? e.start_event.format("DD/MM/YYYY") : null;
    let endEvent = e.end_event ? e.end_event.format("DD/MM/YYYY") : null;

    if (!isCursoCongresso && !isFormacaoOnline && !isSobPesquisa) {
      notification.warning({
        description:
          'Indique se pretende um "Curso e Congresso" ou uma "Formação Online".',
      });
      return;
    }

    if (e.titulo.length == 0 || fileApresentacaoList.length == 0) {
      notification.error({
        description: "Para criar uma novo, preencha todos os campos.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("titulo", e.titulo);
    formData.append("file", fileApresentacaoList[0]);
    formData.append("descricao", e.descricao);
    formData.append("start_post", startPost);
    formData.append("end_post", endPost);
    formData.append("start_event", startEvent);
    formData.append("end_event", endEvent);
    formData.append("external_link", e.external_link);
    formData.append("curso_congresso", isCursoCongresso ? 1 : 0);
    formData.append("formacao_online", isFormacaoOnline ? 1 : 0);
    formData.append("sob_pesquisa", isSobPesquisa ? 1 : 0);
    formData.append("show_socios", showSocios ? 1 : 0);
    formData.append("show_nao_socios", showNaoSocios ? 1 : 0);
    formData.append("show_nao_registados", showNaoRegistados ? 1 : 0);
    formData.append("categoria", categoriaSelecionada);

    // You can use any AJAX library you like
    fetch("https://api.spap.pt/api/admin/store-apresentacao", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            if (data.message == "already_exists") {
              notification.error({
                description: "Já existe uma publicação com o mesmo nome.",
              });
            } else {
              form.resetFields();
              setfileApresentacaoList([]);
              setCategoriaSelecionada(null);
              setCategoriaSelecionadaEdit(null);
              handleApresentacoes(data.apresentacoes, data.editors);
              notification.success({
                description: "A publicação foi criada com sucesso!",
              });
            }
          })
          .catch((err) => {});
      })
      .then(() => {})
      .catch(() => {})
      .finally(() => {});
  };

  const propApresentacaoEdit = {
    onRemove: (file) => {
      fileApresentacaoListEdit([]);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });
        setfileApresentacaoListEdit((current) => []);
        return Upload.LIST_IGNORE;
      }
      setfileApresentacaoListEdit([...fileApresentacaoListEdit, file]);
    },
    fileApresentacaoListEdit,
  };

  const handleEditApresentacao = (e) => {
    let startPost = e.start_post ? e.start_post.format("DD/MM/YYYY") : null;
    let endPost = e.end_post ? e.end_post.format("DD/MM/YYYY") : null;
    let startEvent = e.start_event ? e.start_event.format("DD/MM/YYYY") : null;
    let endEvent = e.end_event ? e.end_event.format("DD/MM/YYYY") : null;

    if (!isCursoCongressoEdit && !isFormacaoOnlineEdit) {
      notification.warning({
        description:
          'Indique se pretende um "Curso e Congresso" ou uma "Formação Online".',
      });
      return;
    }

    if (e.titulo.length == 0 || descricaoApresentacaoEdit.length == 0) {
      notification.error({
        description: "Para criar uma novo, preencha todos os campos.",
      });
      return;
    }

    const formData = new FormData();

    if (fileApresentacaoListEdit.length) {
      formData.append("file", fileApresentacaoListEdit[0]);
    }

    formData.append("apresentacaoId", apresentacaoIdEdit);
    formData.append("titulo", e.titulo);
    formData.append("categoria", categoriaSelecionadaEdit);
    formData.append("descricao", descricaoApresentacaoEdit);
    formData.append("start_post", startPost);
    formData.append("end_post", endPost);
    formData.append("start_event", startEvent);
    formData.append("end_event", endEvent);
    formData.append("external_link", e.external_link);
    formData.append("curso_congresso", isCursoCongressoEdit ? 1 : 0);
    formData.append("formacao_online", isFormacaoOnlineEdit ? 1 : 0);
    formData.append("sob_pesquisa", isSobPesquisaEdit ? 1 : 0);
    formData.append("show_socios", showSociosEdit ? 1 : 0);
    formData.append("show_nao_socios", showNaoSociosEdit ? 1 : 0);
    formData.append("show_nao_registados", showNaoRegistadosEdit ? 1 : 0);

    setUploading(true);

    // You can use any AJAX library you
    fetch("https://api.spap.pt/api/admin/update-apresentacao", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        setShowApresentacaoDrawer(false);
        setCategoriaSelecionada(null);
        setCategoriaSelecionadaEdit(null);
        handleApresentacoes(data.apresentacoes, data.editors);
        setfileApresentacaoListEdit([]);
        notification.success({
          description: "A publicação foi atualizada com sucesso!",
        });
      });
    });
  };

  const handleRemoveApresentacao = () => {
    axios
      .post(
        "https://api.spap.pt/api/admin/remove-apresentacao",
        { idToRemove },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + session_storage.token,
          },
        }
      )
      .then((res) => {
        setIdToRemove("");
        setRemoveApresentacaoModalOpen(false);
        if (res.status == 200) {
          session_storage.all_data.apresentacoes = res.data.apresentacoes;
          localStorage.setItem("session_data", JSON.stringify(session_storage));
          handleApresentacoes(res.data.apresentacoes, res.data.editors);
          notification.success({
            description: "A apresentação foi removida com sucesso!",
          });
        }
      })
      .catch((error) => {
        // notification.error({description: 'Erro ao remover a imagem da galeria! Tente novamente.'});
      });
  };

  const openRemoveApresentacaoModal = (id, titulo) => {
    setIdToRemove(id);
    setTitleToRemove(titulo);
    setRemoveApresentacaoModalOpen(true);
  };

  const handleOrdem = (array, tipo) => {
    let ordemapresentacoes = [];
    array.map(function (item, index) {
      ordemapresentacoes.push({ ordem: index, id: item.id });
    });

    if (tipo == "formacoes") {
      setFormacoesOnline(array);
    } else {
      setCursosCongressos(array);
    }

    var bodyFormData = new FormData();

    bodyFormData.append("array", JSON.stringify(ordemapresentacoes));

    fetch("https://api.spap.pt/api/admin/set-ordem-apresentacao", {
      method: "POST",
      body: bodyFormData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        // handleApresentacoes(data.apresentacoes);
      });
    });
  };

  return (
    <WrapperCardApresentacao>
      <Card>
        <Form
          form={form}
          onFinish={handleApresentacao}
          className="edit-post-form"
        >
          <CardHeader>
            <Row align={"middle"}>
              <Col span={8}>
                <Title>"Cursos e congressos" ou "Formação Online"</Title>

                <p className="text">
                  Ambos disponíveis para consultar na página Formação
                </p>
              </Col>
              <Col span={16} align="right">
                <Space size={20} className="justify-end" align={"middle"}>
                  <Space className="justify-end w-100 ">
                    <Form.Item name="start_post" style={{ width: "100%" }}>
                      <DatePicker
                        placement="bottomRight"
                        className="datepicker-input"
                        format={"DD/MM/YYYY"}
                        placeholder="Data de Publicação"
                      />
                    </Form.Item>
                    <Form.Item name="end_post" style={{ width: "100%" }}>
                      <DatePicker
                        placement="bottomRight"
                        className="datepicker-input"
                        format={"DD/MM/YYYY"}
                        placeholder="Data de Expiração"
                      />
                    </Form.Item>
                  </Space>
                </Space>
              </Col>
            </Row>
          </CardHeader>
          <Divider style={{ margin: "12px 0" }} />
          <Row gutter={[12, 18]} align="bottom" justify={"space-between"}>
            <Col span={15}>
              <label className="text">Título</label>
              <Form.Item
                name="titulo"
                rules={[{ required: true, message: "O título é obrigatório" }]}
                style={{ width: "100%" }}
              >
                <Input placeholder="Título" style={styles.input_class} />
              </Form.Item>
            </Col>
            <Col span={7} align="right" className="w-100">
              <Space className="justify-end w-100 space-dates">
                <Space
                  direction="vertical"
                  align="start"
                  size={0}
                  className="w-100"
                >
                  <label className="text">Início</label>
                  <Form.Item name="start_event" style={{ width: "100%" }}>
                    <DatePicker
                      placement="bottomRight"
                      className="datepicker-input"
                      format={"DD/MM/YYYY"}
                      placeholder="Início"
                    />
                  </Form.Item>
                </Space>
                <Space direction="vertical" align="start" size={0}>
                  <label className="text">Fim</label>
                  <Form.Item name="end_event" style={{ width: "100%" }}>
                    <DatePicker
                      placement="bottomRight"
                      className="datepicker-input"
                      format={"DD/MM/YYYY"}
                      placeholder="Fim"
                    />
                  </Form.Item>
                </Space>
              </Space>
            </Col>
          </Row>
          <Row gutter={[12, 12]} align={"top"}>
            <Col span={6}>
              <p
                className="text"
                style={{ marginBottom: "0px" }}
                align="center"
              >
                Tamanho máximo de upload (1 MB)
              </p>
              <Dragger
                {...propApresentacao}
                style={{ height: "100%" }}
                fileList={[...fileApresentacaoList]}
              >
                <p className="ant-upload-drag-icon">
                  <IconUpload />
                </p>
                <p className="ant-upload-text text">Upload da imagem</p>
                <p className="ant-upload-hint">Faça Drag and drop aqui</p>
              </Dragger>
            </Col>
            <Col span={18}>
              <Row gutter={12}>
                <Col span={12}>
                  <div>
                    <label className="text">Template de descrição</label>
                    <Form.Item
                      name="descricao"
                      rules={[
                        { required: true, message: "Selecione um template" },
                      ]}
                      style={{ width: "100%" }}
                    >
                      <Select
                        placeholder="Selecionar template"
                        style={{ width: "100%" }}
                        options={templates.map((tpl) => ({
                          value: tpl.id,
                          label: tpl.name,
                        }))}
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={12}>
                  <div>
                    <label className="text">Categoria</label>
                    <Select
                      style={{ width: "100%" }}
                      value={categoriaSelecionada}
                      onChange={(value) => setCategoriaSelecionada(value)}
                      placeholder="Selecionar categoria"
                      dropdownRender={(menu) => (
                        <>
                          {menu}
                          <Divider style={{ margin: "8px 0" }} />
                          <Space style={{ padding: "0 8px 4px" }}>
                            <Input
                              placeholder="Inserir nova categoria"
                              ref={inputCategoriaRef}
                              value={novaCategoria}
                              onChange={(e) => setNovaCategoria(e.target.value)}
                            />
                            <Button type="text" onClick={handleAddCategoria}>
                              Adicionar à lista
                            </Button>
                          </Space>
                        </>
                      )}
                      options={categorias.map((cat) => ({
                        label: cat,
                        value: cat,
                      }))}
                    />
                  </div>
                </Col>
              </Row>
              <div>
                <label className="text">Link externo</label>
                <Form.Item name="external_link" style={{ width: "100%" }}>
                  <Input
                    placeholder="Link externo (https://...)"
                    style={styles.input_class}
                  />
                </Form.Item>
              </div>
              <div>
                <label className="text">
                  Visibilidade&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </label>
                <Space size={20} style={{ marginTop: "10px" }}>
                  <Space>
                    <span className="regular-text">Sócios</span>
                    <Switch checked={showSocios} onChange={setShowSocios} />
                  </Space>

                  <Space>
                    <span className="regular-text">Não Sócios</span>
                    <Switch
                      checked={showNaoSocios}
                      onChange={setShowNaoSocios}
                    />
                  </Space>

                  <Space>
                    <span className="regular-text">Não Registados</span>
                    <Switch
                      checked={showNaoRegistados}
                      onChange={setShowNaoRegistados}
                    />
                  </Space>
                </Space>
              </div>
              <div className="mt-1">
                <label className="text">
                  Secção&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </label>
                <Space size={20}>
                  <Space>
                    <span className="regular-text">Curso e Congresso</span>
                    {isCursoCongresso == 1 || isCursoCongresso == true ? (
                      <>
                        {" "}
                        <Switch
                          checked
                          onChange={(e) => setIsCursoCongresso(e)}
                        />
                      </>
                    ) : (
                      <>
                        <Switch onChange={(e) => setIsCursoCongresso(e)} />
                      </>
                    )}
                  </Space>
                  <Space>
                    <span className="regular-text">Formação Online</span>
                    {isFormacaoOnline == 1 || isFormacaoOnline == true ? (
                      <>
                        {" "}
                        <Switch
                          checked
                          onChange={(e) => setIsFormacaoOnline(e)}
                        />
                      </>
                    ) : (
                      <>
                        <Switch onChange={(e) => setIsFormacaoOnline(e)} />
                      </>
                    )}
                  </Space>
                  <Space>
                    <span className="regular-text">
                      Sob pesquisa / escondido
                    </span>
                    {isSobPesquisa == 1 || isSobPesquisa == true ? (
                      <Switch checked onChange={(e) => setIsSobPesquisa(e)} />
                    ) : (
                      <Switch onChange={(e) => setIsSobPesquisa(e)} />
                    )}
                  </Space>
                </Space>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}></Col>
          </Row>
          <Divider style={{ margin: "12px 0" }} />
          <Row justify={"end"}>
            <Button
              type="primary"
              className="cta publish"
              htmlType="submit"
              align="end"
            >
              Publicar <IconOk className="icon icon-ok" />
            </Button>
          </Row>
        </Form>
      </Card>
      <WrapperCardList>
        <Divider>Cursos e Congressos</Divider>
        {cursosCongressos?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem apresentações disponíveis.
          </p>
        )}
        {cursosCongressos?.length > 0 && (
          <>
            <ReactSortable
              list={cursosCongressos}
              setList={(e) => handleOrdem(e, "apresentacoes")}
              className="div-sortable"
            >
              {cursosCongressos.map((item, index) => {
                let textPreview = item?.descricaoParaMostrar
                  ?.replace(/<[^>]*>/g, "") // Remove todas as tags HTML
                  .slice(0, 140);
                if (item.descricaoParaMostrar.length > 140)
                  textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"apresentacoes-" + item.id}
                      className="div-apresentacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemoveApresentacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        <div
                          className="text-preview-desc"
                          dangerouslySetInnerHTML={{ __html: textPreview }}
                        ></div>
                      </div>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Apresentacao-" + index}
                              onClick={() => clickToApresentacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                            </Space>
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>

                            {item.status == "published" && (
                              <Tag color="green">Publicado</Tag>
                            )}
                            {item.status == "expired" && (
                              <Tag color="red">Expirado</Tag>
                            )}
                            {item.status == "scheduled" && (
                              <Tag color="blue">
                                Agendado para {item.start_post}
                              </Tag>
                            )}
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "https://spap.pt/ferramentas-uteis/formacao/cursos-congressos/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Divider>Formações Online</Divider>
        {formacoesOnline?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem apresentações disponíveis.
          </p>
        )}
        {formacoesOnline?.length > 0 && (
          <>
            <ReactSortable
              list={formacoesOnline}
              setList={(e) => handleOrdem(e, "formacoes")}
              className="div-sortable"
            >
              {formacoesOnline.map((item, index) => {
                let textPreview = item?.descricaoParaMostrar
                  ?.replace(/<(h2|h3|img|b|strong)[^>]*>/g, "<p>")
                  .slice(0, 100);
                if (item.descricaoParaMostrar.length > 120)
                  textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"apresentacoes-" + item.id}
                      className="div-apresentacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemoveApresentacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        <div
                          className="text-preview-desc"
                          style={{
                            fontSize: "12px",
                            lineHeight: "1.4",
                            color: "rgb(194, 196, 212)",
                          }}
                          dangerouslySetInnerHTML={{ __html: textPreview }}
                        ></div>
                      </div>

                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Apresentacao-" + index}
                              onClick={() => clickToApresentacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                            </Space>
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>

                            {item.status == "published" && (
                              <Tag color="green">Publicado</Tag>
                            )}
                            {item.status == "expired" && (
                              <Tag color="red">Expirado</Tag>
                            )}
                            {item.status == "scheduled" && (
                              <Tag color="blue">
                                Agendado para {item.start_post}
                              </Tag>
                            )}
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "http://spap.pt/ferramentas-uteis/formacao/formacao-online/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Divider>Sob pesquisa / Escondido</Divider>
        {sobPesquisa?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem apresentações disponíveis.
          </p>
        )}
        {sobPesquisa?.length > 0 && (
          <>
            <ReactSortable
              list={formacoesOnline}
              setList={(e) => handleOrdem(e, "formacoes")}
              className="div-sortable"
            >
              {sobPesquisa.map((item, index) => {
                let textPreview = item?.descricaoParaMostrar
                  ?.replace(/<(h2|h3|img|b|strong)[^>]*>/g, "<p>")
                  .slice(0, 100);
                if (item.descricaoParaMostrar.length > 120)
                  textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"apresentacoes-" + item.id}
                      className="div-apresentacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemoveApresentacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        <div
                          className="text-preview-desc"
                          style={{
                            fontSize: "12px",
                            lineHeight: "1.4",
                            color: "rgb(194, 196, 212)",
                          }}
                          dangerouslySetInnerHTML={{ __html: textPreview }}
                        ></div>
                      </div>

                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Apresentacao-" + index}
                              onClick={() => clickToApresentacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                            </Space>
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>

                            {item.status == "published" && (
                              <Tag color="green">Publicado</Tag>
                            )}
                            {item.status == "expired" && (
                              <Tag color="red">Expirado</Tag>
                            )}
                            {item.status == "scheduled" && (
                              <Tag color="blue">
                                Agendado para {item.start_post}
                              </Tag>
                            )}
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "http://spap.pt/ferramentas-uteis/apresentacao/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Drawer
          className="edit-public"
          key={"editar-apresentacao-" + apresentacaoIdEdit}
          title="Editar Publicação"
          width={1200}
          onClose={() => setShowApresentacaoDrawer(false)}
          open={showApresentacaoDrawer}
          bodyStyle={{
            paddingTop: 15,
          }}
          extra={
            <Space>
              <Button onClick={() => setShowApresentacaoDrawer(false)}>
                Cancelar
              </Button>
              <Button
                onClick={() => editForm.submit()}
                type="submit"
                style={{
                  borderRadius: "6px",
                  background: "#494D7D",
                  color: "#fff",
                }}
              >
                Guardar
              </Button>
            </Space>
          }
        >
          <Form form={editForm} onFinish={handleEditApresentacao}>
            <Row justify={"space-between"} align={"middle"}>
              <Col className="d-flex gap-20">
                <div className="d-flex gap-10">
                  <span className="regular-text">Curso e Congresso</span>
                  {isCursoCongressoEdit == 1 || isCursoCongressoEdit == true ? (
                    <>
                      {" "}
                      <Switch
                        checked
                        onChange={(e) => setIsCursoCongressoEdit(e)}
                      />
                    </>
                  ) : (
                    <>
                      <Switch onChange={(e) => setIsCursoCongressoEdit(e)} />
                    </>
                  )}
                </div>
                <div className="d-flex gap-10">
                  <span className="regular-text">Formação Online</span>
                  {isFormacaoOnlineEdit == 1 || isFormacaoOnlineEdit == true ? (
                    <>
                      {" "}
                      <Switch
                        checked
                        onChange={(e) => setIsFormacaoOnlineEdit(e)}
                      />
                    </>
                  ) : (
                    <>
                      <Switch onChange={(e) => setIsFormacaoOnlineEdit(e)} />
                    </>
                  )}
                </div>
                <div className="d-flex gap-10">
                  <span className="regular-text">Sob pesquisa / escondido</span>
                  {isSobPesquisaEdit == 1 || isSobPesquisaEdit == true ? (
                    <Switch checked onChange={(e) => setIsSobPesquisaEdit(e)} />
                  ) : (
                    <Switch onChange={(e) => setIsSobPesquisaEdit(e)} />
                  )}
                </div>
              </Col>
              <Col>
                <Space className="justify-end h-40">
                  <Form.Item name="start_post" style={{ width: "100%" }}>
                    <DatePicker
                      placement="bottomRight"
                      className="datepicker-input"
                      format={"DD/MM/YYYY"}
                      placeholder="Data de Publicação"
                    />
                  </Form.Item>
                  <Form.Item name="end_post" style={{ width: "100%" }}>
                    <DatePicker
                      placement="bottomRight"
                      className="datepicker-input"
                      format={"DD/MM/YYYY"}
                      placeholder="Data de Expiração"
                    />
                  </Form.Item>
                </Space>
              </Col>
            </Row>
            <Divider style={{ background: "#fff", margin: "12px 0" }}></Divider>
            <Col>
              <Row align={"middle"}>
                <Col span={12}>
                  <h5 style={{ marginBottom: "10px", fontSize: "18px" }}>
                    Upload da imagem
                  </h5>
                  <p>
                    Poderá fazer o upload de uma nova imagem de destaque
                    clicando na imagem do lado direito.
                  </p>
                </Col>
                <Col span={12}>
                  <Dragger
                    {...propApresentacaoEdit}
                    fileList={[...fileApresentacaoListEdit]}
                    style={{
                      marginBottom: "5px",
                      width: "100%",
                      backgroundImage:
                        "url(https://api.spap.pt/apresentacoes/" +
                        apresentacaoIdEdit +
                        "/" +
                        imagemDestaqueEdit +
                        ")",
                      backgroundSize: "cover",
                    }}
                  >
                    <div style={{ opacity: 0 }}>
                      <p className="ant-upload-drag-icon">
                        <IconUpload />
                      </p>
                      <p className="ant-upload-text text">Upload da imagem </p>
                      <p className="ant-upload-hint">Faça Drag and drop aqui</p>
                    </div>
                  </Dragger>
                </Col>
              </Row>
              <Divider
                style={{ background: "#fff", margin: "12px 0" }}
              ></Divider>

              <Row justify={"space-between"} align={"bottom"}>
                <Col span={15}>
                  <h6 style={styles.h6_label}>Título</h6>
                  <Form.Item name="titulo" style={{ width: "100%" }}>
                    <Input
                      key={"titulo-apresentacao-" + apresentacaoIdEdit}
                      placeholder="Título"
                      style={styles.input_class}
                      required
                    />
                  </Form.Item>
                </Col>
                <Col className="col-dates">
                  <Space className="justify-end w-100">
                    <div>
                      <h6 style={styles.h6_label}>Início</h6>
                      <Form.Item name="start_event" style={{ width: "100%" }}>
                        <DatePicker
                          placement="bottomRight"
                          className="datepicker-input"
                          format={"DD/MM/YYYY"}
                          placeholder="Data de Início"
                        />
                      </Form.Item>
                    </div>
                    <div>
                      <h6 style={styles.h6_label}>Fim</h6>
                      <Form.Item name="end_event" style={{ width: "100%" }}>
                        <DatePicker
                          placement="bottomRight"
                          className="datepicker-input"
                          format={"DD/MM/YYYY"}
                          placeholder="Data de Fim"
                        />
                      </Form.Item>
                    </div>
                  </Space>
                </Col>
                <Col span={24}>
                  <Row gutter={12}>
                    <Col span={12}>
                      <h6 style={styles.h6_label}>Categoria</h6>
                      <Select
                        style={{ width: "100%" }}
                        value={categoriaSelecionadaEdit}
                        className="h-40"
                        onChange={(value) => setCategoriaSelecionadaEdit(value)}
                        placeholder="Selecionar categoria"
                        dropdownRender={(menu) => (
                          <>
                            {menu}
                            <Divider style={{ margin: "8px 0" }} />
                            <Space style={{ padding: "0 8px 4px" }}>
                              <Input
                                placeholder="Inserir nova categoria"
                                ref={inputCategoriaRef}
                                value={novaCategoria}
                                onChange={(e) =>
                                  setNovaCategoria(e.target.value)
                                }
                              />
                              <Button type="text" onClick={handleAddCategoria}>
                                Adicionar nova categoria
                              </Button>
                            </Space>
                          </>
                        )}
                        options={categorias.map((cat) => ({
                          label: cat,
                          value: cat,
                        }))}
                      />
                    </Col>

                    <Col span={12}>
                      <h6 style={styles.h6_label}>Link externo</h6>
                      <Form.Item name="external_link" style={{ width: "100%" }}>
                        <Input
                          placeholder="Link externo (https://...)"
                          style={styles.input_class}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <h6 style={styles.h6_label}>Visibilidade</h6>

                  <Space size={40}>
                    <Space>
                      <span className="regular-text">Sócios</span>
                      <Switch
                        checked={showSociosEdit}
                        onChange={setShowSociosEdit}
                      />
                    </Space>

                    <Space>
                      <span className="regular-text">Não Sócios</span>
                      <Switch
                        checked={showNaoSociosEdit}
                        onChange={setShowNaoSociosEdit}
                      />
                    </Space>

                    <Space>
                      <span className="regular-text">Não Registados</span>
                      <Switch
                        checked={showNaoRegistadosEdit}
                        onChange={setShowNaoRegistadosEdit}
                      />
                    </Space>
                  </Space>
                </Col>

                <Col span={24}>
                  <h6 style={styles.h6_label}>Descrição</h6>
                  {isTemplateMode ? (
                    <>
                      <Form.Item name="descricao" style={{ width: "100%" }}>
                        <Select
                          placeholder="Selecionar template"
                          className="h-40"
                          onChange={(value) =>
                            setDescricaoApresentacaoEdit(value)
                          }
                          options={templates.map((tpl) => ({
                            value: String(tpl.id),
                            label: tpl.name,
                          }))}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      {!editModeDescricao && (
                        <>
                          <Button onClick={() => editDescricao()}>
                            Editar
                          </Button>
                          <br />
                          <br />
                          <div
                            className="event__content"
                            dangerouslySetInnerHTML={{
                              __html: descricaoApresentacaoEdit,
                            }}
                          ></div>
                        </>
                      )}

                      {editModeDescricao && (
                        <ReactQuill
                          ref={quillRef}
                          key={"descricao-apresentacao-" + apresentacaoIdEdit}
                          modules={modules}
                          formats={formats}
                          value={descricaoApresentacaoEdit}
                          onChange={(content, delta, source, editor) => {
                            setDescricaoApresentacaoEdit(editor.getHTML());
                          }}
                          theme="snow"
                        />
                      )}
                    </>
                  )}
                </Col>
              </Row>
            </Col>
          </Form>
        </Drawer>

        <Modal
          key={"remove-apresentacao-" + idToRemove}
          title="Está prestes a eliminar um Apresentacao"
          open={removeApresentacaoModalOpen}
          onOk={handleRemoveApresentacao}
          onCancel={() => setRemoveApresentacaoModalOpen(false)}
          okText="Confirmar"
          cancelText="Cancelar"
        >
          <p>
            Tem a certeza que pretende remover o Apresentacao{" "}
            <b>'{titleToRemove}'</b>?
          </p>
        </Modal>
      </WrapperCardList>
    </WrapperCardApresentacao>
  );
}
